import { useEffect, useRef } from "react";
import { approachItems } from "@/mocks/home";

export default function ApproachSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(".animate-on-scroll");
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-14 md:py-20 bg-gradient-to-b from-background-100 to-background-50">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10">
          <div className="w-full md:w-1/2 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 font-heading">
              Notre Approche
            </h2>
            <div className="w-24 h-1 bg-primary-500 rounded-full mb-8"></div>
            <p className="text-foreground-50 mb-6 leading-relaxed">
              Chez Melio LM, nous accompagnons chaque projet avec exigence, clarté et engagement. Notre mission : vous simplifier la vie en prenant en charge la gestion complète de votre événement, tout en veillant à ce que chaque détail soit à la hauteur de vos attentes.
            </p>
            <ul className="space-y-4">
              {approachItems.map((item) => (
                <li key={item} className="flex items-start">
                  <span className="text-primary-500 font-bold mt-1 mr-3 flex-shrink-0">✓</span>
                  <p className="text-foreground-50">{item}</p>
                </li>
              ))}
            </ul>
          </div>
          <div className="w-full md:w-1/2 animate-on-scroll opacity-0 translate-y-6 transition-all duration-700 delay-150">
            <img
              src="https://static.readdy.ai/image/254cde0d10dfb5832a5e0a0044c661fc/eb322b7b27455824b67b8d231669f3bd.jpeg"
              alt="Notre approche"
              className="rounded-lg shadow-2xl w-full h-auto object-cover"
              style={{ maxHeight: "500px" }}
            />
          </div>
        </div>
      </div>
      <style>{`
        .animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}